export enum FilterTemplate {
  MultiSelectFilterTemplate = 'MultiSelectFilterTemplate',
  SearchFilterTemplate = 'SearchFilterTemplate',
}
